import React, { useRef, useState, useEffect } from "react";
import { Menu } from "primereact/menu";
import { TieredMenu } from "primereact/tieredmenu";
import { Button } from "primereact/button";
import { Route, Routes, useNavigate, useLocation } from "react-router-dom";
import Dashboard from "../pages/Dashboard";
// import Members from "../pages/Members";

const Main = () => {
  const menu = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("");

  useEffect(() => {
    setActiveTab(location.pathname);
  }, [location.pathname]);
  const clearSession = () => {
    sessionStorage.clear();
    // localStorage.removeItem('sessionId');
    navigate("/");
  };

  const displayContent = () => {
    return (
      <Routes>
        <Route exact path="/dashboard" element={<Dashboard />} />
        {/* <Route exact path="/members" element={<Members />} /> */}
      </Routes>
    );
  };

  const items1 = [
    {
      label: "Log out",
      icon: "pi pi-sign-out",
      command: () => {
        clearSession();
      },
      // style: { fontFamily: '"Poppins", sans-serif' }
    },
  ];

  const SuperItems = [
    {
      label: (
        <p
          className={`m-0 ${
            activeTab === "/main/dashboard" ? "active-text" : ""
          }`}
        >
          Dashboard
        </p>
      ),
      icon:
        activeTab === "/main/dashboard" ? (
          <i
            className="pi pi-chart-pie"
            style={{ fontSize: "22px", color: "#7265e2", paddingRight: "10px" }}
          />
        ) : (
          <i
            className="pi pi-chart-pie"
            style={{ fontSize: "24px", paddingRight: "10px" }}
          />
        ),
      className: activeTab === "/main/dashboard" ? "active-tab" : "",
      command: () => {
        setActiveTab("/main/dashboard");
        navigate("/main/dashboard");
      },
    },
    // {
    //   label: (
    //     <p
    //       className={`m-0 ${
    //         activeTab === "/main/members" ? "active-text" : ""
    //       }`}
    //     >
    //       Members
    //     </p>
    //   ),
    //   icon:
    //     activeTab === "/main/members" ? (
    //       <i
    //         className="pi pi-users"
    //         style={{ fontSize: "22px", color: "#7265e2", paddingRight: "10px" }}
    //       />
    //     ) : (
    //       <i
    //         className="pi pi-users"
    //         style={{ fontSize: "22px", paddingRight: "10px" }}
    //       />
    //     ),
    //   className: activeTab === "/main/members" ? "active-tab" : "",
    //   command: () => {
    //     setActiveTab("/main/members");
    //     navigate("/main/members");
    //   },
    // },
  ];
  return (
    <>
      <div className="sidebar">
        <div className="flex justify-content-center mt-5">
          <img src="/Logo2.png" alt="logo" style={{ width: "120px" }} />
        </div>
        <div className="menu-container">
          <Menu model={SuperItems} className="sidebarMenu mt-7 pl-4" />
        </div>
        <div
          className="sidebartieredmenu-container"
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "15px",
          }}
        >
          <TieredMenu model={items1} popup ref={menu} />
          <Button
            className="sidebartieredmenu pi pi-user"
            onClick={(e) => menu.current.toggle(e)}
          >
            <span className="menuFont">Administrator</span>{" "}
            <i className="pi pi-chevron-up" />
          </Button>
        </div>
      </div>
      <div className="cardStyle">
        <div>{displayContent()}</div>
      </div>
    </>
  );
};
export default Main;
